"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// This wrapper is used to wrap the analytics object, to limit exposed methods and provide our own load method.
// Once everything is loaded we replace window.analytics with instance of Analytics which is returned from AnalyticsBrowser.load().

class AnalyticsWrapper {
  constructor(analytics, analyticsLoader) {
    _defineProperty(this, "analytics", void 0);
    _defineProperty(this, "analyticsLoader", void 0);
    this.analytics = analytics;
    this.analyticsLoader = analyticsLoader;
  }
  page(name, properties, options) {
    this.analytics.page(name, properties, options);
  }
  track(name, properties, options) {
    this.analytics.track(name, properties, options);
  }
  trackLink(element, eventName, properties) {
    this.analytics.trackLink(element, eventName, properties);
  }
  identify(userId, traits, options) {
    this.analytics.identify(userId, traits, options);
  }
  reset() {
    this.analytics.reset();
  }
  ready(callback) {
    this.analytics.ready(callback);
  }
  debug(debug) {
    this.analytics.debug(debug);
  }
  original() {
    return this.analytics;
  }
  load(writeKey, options) {
    this.analyticsLoader(writeKey, options);
  }
}
module.exports = AnalyticsWrapper;